// Import everything from autoload folder
import './autoload/content-w-slider.js'; // eslint-disable-line
import './autoload/infinite-ticker.js'; // eslint-disable-line

// Import plugins
import 'jquery-match-height';

/**
 * Scripts which runs after DOM load
 */
$(document).ready(function () {
    /**
     * Make elements equal height
     */
    $('.matchHeight').matchHeight();

    /**
     * Team Member Bio Toggle
     */
    $('.member-card__open-bio').on('click', function(e) {
        e.preventDefault();
        var $card = $(this).closest('.member-card');

        $card.addClass('bio-is-open');

        setTimeout(function() {
            if ($card.hasClass('bio-is-open')) {
                $card.addClass('bio-overflow');
            }
        }, 350);
    });

    $('.close-bio').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.member-card').removeClass('bio-is-open bio-overflow');
    });
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
    if ($(this).scrollTop() > 0) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
});
